import * as Event from '../tools/Event';
import Scroll from '../vendor/scroll-js';
import { addClass, removeClass } from '../tools/DOM';


export const init = () => {
	const SELECTOR = '.js-top';
	const VISIBLE_CLASS = 'is-visible';
	const element = document.querySelector(SELECTOR);
	const scroll = new Scroll(document.body);

	if (!element) return;

	const onClick = (event) => {
		event.preventDefault();

		scroll
			.to(0, 0, {
				easing: 'easeInCubic',
			});
	};

	const checkVisible = () => {
		const height = document.body.scrollHeight;
		const scrolled = document.documentElement.scrollTop || document.body.scrollTop || 0;
		const isPageShort = height <= 2500;
		const isScrolled = scrolled > 200;

		removeClass(element, VISIBLE_CLASS);

		if (isPageShort) return;

		if (isScrolled) {
			addClass(element, VISIBLE_CLASS);
		}
	};


	checkVisible();

	Event.on(document, 'click', onClick, SELECTOR);
	Event.on(window, 'resize scroll', checkVisible);
};
